<style src="./Membership.scss" lang="scss" scoped></style>

<template src="./Membership.html" />

<script>
import Card from '../Card/Card.vue';

export default {
  name: 'Membership',
  components: {
    Card,
  },
  props: ['membership'],
};
</script>
